/** 处理大小值不存在时比较 */
export function bound(position, min, max) {
  var ret = position;
  if (min !== undefined) {
    ret = Math.max(position, min);
  }
  if (max !== undefined) {
    ret = Math.min(ret, max);
  }
  return ret;
}